export default __webpack_public_path__ + "static/media/slide3.a84700da.png";